/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import {
	selectIsLoadingIsLoaded
} from './selectors';
import { listLinesStates } from '../../api/states.list';
import { transform } from './transform';

const {
	reset,
	setItems,
	setIsLoadingIsLoaded,
	setErrorMessage,
	clearErrorMessage
} = createActions(
	{
		RESET: () => ({}),
		SET_ITEMS: ({ items, serverItems }) => ({ items, serverItems }),
		SET_IS_LOADING_IS_LOADED: ({ isLoading, isLoaded } = {}) => ({ isLoading, isLoaded }),
		SET_ERROR_MESSAGE: message => ({ message }),
		CLEAR_ERROR_MESSAGE: () => ({})
	},
	{ prefix: 'DITLineState.main' }
);

const thunkLoadItems = () => async dispatch => {
	dispatch(reset);
	dispatch(
		setIsLoadingIsLoaded({
			isLoading: true,
			isLoaded: false
		})
	);

	try {
		const serverItems = await listLinesStates();
		const items = (serverItems || []).map(i => transform(i));
		dispatch(setItems({ items, serverItems }));
		dispatch(
			setIsLoadingIsLoaded({
				isLoading: false,
				isLoaded: true
			})
		);
	} catch(err) {
		dispatch(setErrorMessage(err?.message || err));
		dispatch(
			setIsLoadingIsLoaded({
				isLoading: false,
				isLoaded: false
			})
		);
	}
};

const thunkLoadItemsIfNotLoaded = () => async (dispatch, getState) => {
	const { isLoading, isLoaded } = selectIsLoadingIsLoaded(getState());
	if (!isLoading && !isLoaded) {
		dispatch(thunkLoadItems());
	}
}

export {
	reset,
	setItems,
	setIsLoadingIsLoaded,
	setErrorMessage,
	clearErrorMessage,

	thunkLoadItems,
	thunkLoadItemsIfNotLoaded,
};
